/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable import/no-extraneous-dependencies */
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
  Input,
  PopoverContent,
  Popover,
  PopoverTrigger,
  Button,
  Badge,
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from "@repo/ui";
import Layout from "components/layout";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  useCreateBulkOrders,
  useGetAllOrders
} from "utils/apis/manage-all-orders.api";
import { process } from "@progress/kendo-data-query";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { formatDate } from "date-fns";
import { UserContext } from "utils/reducers/user";
import {
  useGetCustomers,
  useGetCustomerServicePoints,
  useGetServiceTypes,
  useValidateBulkOrders
} from "utils/apis/lookups.api";
import { CirclePlus, CircleX, SlidersHorizontal } from "lucide-react";
import { saveFilters } from "utils/actions/user";
import { SERVICES_LIST, SERVICE_LINK } from "utils/constant";
import { getLink, readOnlyExcelDate, showToast } from "utils/helper";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import { ExcelRenderer } from "react-excel-renderer";

const pageSize = 25;

const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc"
    }
  ]
};

export default function ManageAllOrders() {
  const user = useContext(UserContext);

  const [dataState, setDataState] = useState<any>(initialDataState);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["all-services"] || {}
  );
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [orderList, setOrderList] = useState<any[]>([]);

  const { data: customers } = useGetCustomers();
  const { data: serviceTypes } = useGetServiceTypes();

  const { data: sourceLocationsData } = useGetCustomerServicePoints(
    filters?.customer?.id || ""
  );
  const { data: onwardLocationsData } = useGetCustomerServicePoints(
    filters?.customer?.id || ""
  );

  const { data: allOrders, isFetching: loadingRequests } = useGetAllOrders({
    cashCenterId: user.CashCenterId,
    serviceType: filters?.serviceType?.id || "",
    pageNumber: currentPage,
    pageRowCount: 25,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    ),
    customerId: filters?.customer?.id || "",
    sourceSPId: filters?.sourceLocation?.id || "",
    onwardSPId: filters?.onwardLocation?.id || ""
  });

  const {
    mutate: validateAllBulkOrders,
    isPending: validateOrdersPending,
    isSuccess: validateOrdersSuccess,
    isError: validateOrdersError,
    data: validateData,
    reset: validateReset
  } = useValidateBulkOrders();

  const {
    mutate: createBulkOrders,
    isPending: createBulkOrdersPending,
    isSuccess: bulkOrderSuccess,
    isError: bulkOrderError
  } = useCreateBulkOrders();

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "all-services": updatedFilter
    });
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value }
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "all-services": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value }
        }
      });
    }
    setCurrentPage(1);
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  function ShowDetailsButtonCell(props: any) {
    const { requestId, jobNo, orderId, serviceType } = props.dataItem;
    return (
      <td className="text-center" {...props}>
        <Link
          to={getLink(serviceType)}
          state={{
            requestId,
            jobNo
          }}
        >
          {orderId}
        </Link>
      </td>
    );
  }

  const fileHandler = (event: any) => {
    const fileObj = event.target.files[0] as File | null;
    if (!fileObj) return;

    if (
      ![
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "text/csv"
      ].includes(fileObj.type)
    ) {
      showToast("error", "File format not supported.");
      return;
    }

    ExcelRenderer(fileObj, (err: any, resp: any) => {
      if (err) {
        showToast("error", err);
      } else {
        const rows = resp.rows;
        const parsed: any[] = [];

        for (let i = 1; i < rows.length; i++) {
          const clientId = String(rows[i][0]);
          const locationBarcode = rows[i][1];
          const onwardLocationBarcode = rows[i][2];
          const stockCollectionLocBarcode = rows[i][3];
          const onwardCashCenterBarcode = rows[i][4];
          const serviceDateTime = rows[i][5];
          const invoicingModel = rows[i][6];
          const serviceType = rows[i][7];
          const jobType = rows[i][8];
          const jobNature = rows[i][9];
          const isPrepack = rows[i][10];
          const isBranchToATM = rows[i][11];
          const routeNo = rows[i][12];
          const requestedBy = rows[i][13];
          const remarks = rows[i][14];

          if (
            !serviceDateTime ||
            !invoicingModel ||
            !serviceType ||
            !jobType ||
            !jobNature
          )
            continue;

          // Build payload with expected keys (exact casing as requested)
          parsed.push({
            clientId,
            locationBarcode,
            onwardLocationBarcode,
            stockCollectionLocBarcode,
            onwardCashCenterBarcode,
            serviceDateTime: readOnlyExcelDate(serviceDateTime),
            invoicingModel,
            serviceType,
            jobType,
            jobNature,
            isPrepack: isPrepack || false,
            isBranchToATM: isBranchToATM || false,
            routeNo,
            requestedBy,
            remarks
          });
        }

        if (parsed.length > 0) {
          setOrderList(parsed);
          validateAllBulkOrders(parsed);
        } else {
          showToast("error", "No data found in excel file.");
        }
      }
    });
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "all-services": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value }
      }
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceLocation, onwardLocation, ...remainingFilters } = filters;
    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val)
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "all-services": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val)
      }
    });
  };

  const handleBillingCustomer = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("customer", val);
  };

  const handleSourceLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("sourceLocation", val);
  };

  const handleDestinationLocation = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("onwardLocation", val);
  };
  const handleServiceType = (val: string) => {
    setCurrentPage(1);
    handleFiltersUpdate("serviceType", val);
  };

  const onConfirmFileOrders = () => {
    if (orderList.length === 0) {
      showToast("error", "No orders to add. Please upload a file first.");
      return;
    }
    createBulkOrders(orderList);
  };

  useEffect(() => {
    if (validateOrdersError || validateData) {
      setOpenFileUpload(false);
      setOrderList([]);
      validateReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateOrdersError, validateData]);

  useEffect(() => {
    if (bulkOrderSuccess) {
      setOpenFileUpload(false);
      setOrderList([]);
      validateReset();
    }
    if (bulkOrderError) {
      setOpenFileUpload(false);
      setOrderList([]);
      validateReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bulkOrderSuccess, bulkOrderError]);

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Manage All Orders </BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Customer"
                      value={JSON.stringify(filters?.customer) || ""}
                      data={customers?.map((item) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.customerId
                        }),
                        label: item.name
                      }))}
                      setValue={handleBillingCustomer}
                    />

                    <Combobox
                      placeholder="Select Source Location"
                      value={JSON.stringify(filters?.sourceLocation) || ""}
                      data={sourceLocationsData?.map((item: any) => ({
                        value: JSON.stringify({
                          name: `${item.barcode}-${item.locationId}`,
                          id: item.servicePointId
                        }),
                        label: `${item.barcode}-${item.locationId}`
                      }))}
                      setValue={handleSourceLocation}
                    />

                    {filters?.serviceType?.id === "B2B" ? (
                      <Combobox
                        placeholder="Select Destination Location"
                        value={JSON.stringify(filters?.onwardLocation) || ""}
                        data={onwardLocationsData?.map((item: any) => ({
                          value: JSON.stringify({
                            name: `${item.barcode}-${item.locationId}`,
                            id: item.servicePointId
                          }),
                          label: `${item.barcode}-${item.locationId}`
                        }))}
                        setValue={handleDestinationLocation}
                      />
                    ) : null}
                  </div>
                </PopoverContent>
              </Popover>

              <div className="max-w-[250px] w-full">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || new Date()}
                  onSelectDate={onOperationDateChanged}
                />
              </div>
              <Select
                onValueChange={handleServiceType}
                value={JSON.stringify(filters?.serviceType)}
              >
                <SelectTrigger className="max-w-[250px] w-full">
                  <SelectValue placeholder="Select Service Type" />
                </SelectTrigger>
                <SelectContent>
                  {serviceTypes?.map((item: any) => (
                    <SelectItem
                      key={item.description}
                      value={JSON.stringify({
                        name: item.description,
                        id: item.description
                      })}
                    >
                      {item.description}
                    </SelectItem>
                  ))}
                </SelectContent>
              </Select>
              {/* <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button variant="secondary" className="gap-2 ml-auto">
                    <CirclePlus /> Create Request
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent className="w-[180px]">
                  <DropdownMenuItem>
                    <Link
                      to="/create-all-service"
                      state={{ createType: "single" }}
                    >
                      Single Request
                    </Link>
                  </DropdownMenuItem>
                  <DropdownMenuItem
                    onClick={() => {
                      setOpenFileUpload(true);
                    }}
                    className="cursor-pointer"
                  >
                    Bulk Requests
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu> */}
              <Input
                className="max-w-[420px] w-full"
                value={filters.searchCriteria?.id}
                onChange={onFilterSearch}
                placeholder="Job No, Route No and Status"
              />
            </div>
            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null
              )}
            </div>
            <div className="border-b mb-3 bg-accent" />
            {loadingRequests ? (
              <div className="k-loading-mask">
                <span className="k-loading-text">Loading</span>
                <div className="k-loading-image" />
                <div className="k-loading-color" />
              </div>
            ) : null}
            <Grid
              className="text-xs"
              data={process(allOrders?.data || [], {
                ...dataState,
                skip: 0
              })}
              {...dataState}
              pageable
              onPageChange={onPageChange}
              pageSize={pageSize}
              total={allOrders?.totalRecords}
              skip={(currentPage - 1) * pageSize}
              take={pageSize}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              size="small"
            >
              <Column
                field="orderId"
                title="Order Id"
                cell={ShowDetailsButtonCell}
                width={160}
              />
              <Column field="jobNo" title="Job #" width={80} />
              <Column field="customer" title="Customer" width={240} />
              <Column field="barcode" title="Barcode" width={200} />
              <Column field="locationId" title="Location ID" width={200} />
              <Column field="locationName" title="Name" width={280} />
              <Column
                field="routeNo"
                title="Route"
                className="text-center"
                width={180}
              />
              <Column
                field="serviceDate"
                title="Service Date"
                width={140}
                className="text-center"
              />
              <Column
                field="serviceType"
                title="Service Type"
                width={140}
                className="text-center"
              />
              <Column
                field="jobType"
                title="Job Type"
                width={140}
                className="text-center"
              />
              <Column
                width={140}
                field="status"
                title="Status"
                className="text-center"
              />
              <Column field="remarks" title="Remarks" width={200} />
            </Grid>
          </CardDescription>
        </CardContent>
      </Card>
      {/* Bulk Upload Dialog */}
      <Dialog
        open={openFileUpload}
        onOpenChange={(val) => {
          setOrderList([]);
          setOpenFileUpload(val);
        }}
      >
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Upload Orders</DialogTitle>
          </DialogHeader>
          <DialogDescription className="pt-6">
            {orderList.length > 0 ? (
              <div className="flex flex-col items-center justify-center py-5">
                <p className="mb-5 text-gray-500 dark:text-gray-400">
                  File uploaded successfully! Now add orders.
                </p>
                <Button
                  variant="secondary"
                  onClick={onConfirmFileOrders}
                  isLoading={createBulkOrdersPending || validateOrdersPending}
                  disabled={!validateOrdersSuccess}
                >
                  Add Orders
                </Button>
              </div>
            ) : (
              <label
                htmlFor="dropzone-file"
                className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
              >
                <span className="sr-only">Upload Orders File</span>
                <div className="flex flex-col items-center justify-center pt-5 pb-6">
                  <svg
                    className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                  <p className="mb-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="font-semibold">Click to upload</span> or
                    drag and drop
                  </p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    XLS, XLSX, CSV (MAX. 5GB)
                  </p>
                </div>
                <input
                  id="dropzone-file"
                  accept=".xlsx, .xls, .csv"
                  type="file"
                  className="hidden"
                  onChange={fileHandler}
                />
              </label>
            )}
          </DialogDescription>
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
